import React, { createRef, useEffect, useRef, useState } from 'react'
import * as routeLink from "../../constants/routeLink";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addRef, claim, getUser } from '../../services/services';
import { setUser } from '../../actions/apiIndex';
import Loading from "../../components/Loading/index";

const Index = (props) => {
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;
  useEffect(() => {
    const body_ = document.querySelector(".box-mobile");


    if (body_) {

      body_.style.backgroundImage = `url(${routeLink.domain}/assets/imgs/affiliate_bg.png)`
      body_.style.backgroundPosition = "center"
      body_.style.backgroundSize = "cover"
    }
    return () => {
      body_.style.backgroundImage = ``
      body_.style.backgroundPosition = "center"
      body_.style.backgroundSize = "cover"
    };
  }, []);

  const inputRef = useRef(null);
  const inputRef1 = useRef(null);
  const handleCopy = (type) => {
    if (type == 1) {
      let referralLink = `https://t.me/coinx_bsc_bot/start=${user?.userID.replaceAll('user', '')}`;
      navigator.clipboard.writeText(referralLink)
        .then(() => {
        
          toast("Copied to clipboard")
        })
        .catch(err => {
          toast('Failed to copy: ', err)
        
        });

    } else {
      share_();
    }

  };

  const share_ = () => {
    if (!user?.userID) {
      return
    }
    let referralLink = `https://t.me/coinx_bsc_bot/start?ref=${user?.userID.replaceAll('user', '')}`;
    // navigator.clipboard.writeText(referralLink)
    const telegramShareLink = `https://t.me/share/url?url=${encodeURIComponent(referralLink)}`;
    window.open(telegramShareLink, '_blank');
  }
  return (
    <div className="w-100 show-nav p-4 banner">
      <div className="container-custom h-100 d-flex justify-content-center flex-column align-items-center">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6 d-flex justify-content-start flex-column align-items-start mb-4">
            <p className="title  text-left fw-bold fs-4 ">
              You can earn 10% bonus points and 0.4% bet volume from your friends
            </p>
            <div className="d-flex justify-content-between align-items-center  mb-3">
              {/* <button className="button primary btnMainBorder w-100"><span className="fs-5">Buy now
                $100</span></button> */}

            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6 ">
            <div className="bgSecondary4  borderPrimary affiliateInfo">
              <div className="col-lg-12">
                <p className="font-14 color-light-gray colorSecondary2 mb-2 label">

                  Registration link</p>
                <div className="inputGroup mb-3 position-relative">
                  <input ref={inputRef} readOnly="readOnly" type="text" aria-label="Recipient's username"
                    aria-describedby="button-addon2" className="form-control w-100" value={user?.userID} />
                  <div className="input-append d-flex align-items-center h-100">
                    <button type="button" id="button-addon2" className="btn button primary" onClick={() => handleCopy(1)}>Copy</button>
                  </div>
                </div>


              </div>
              <div className="col-lg-6">
                <p className="font-14 color-light-gray mb-2 colorSecondary2 label">

                  Invitation code</p>
                <div className="inputGroup mb-3 position-relative">
                  <input ref={inputRef1} readOnly="readOnly" type="text" aria-label="Recipient's username"
                    aria-describedby="button-addon2" className="form-control w-100" value={user?.userID} />
                  <div className="input-append d-flex align-items-center h-100">
                    <button type="button" id="button-addon2" className="btn button primary" onClick={() => handleCopy(2)}>Share</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index;
